import { render, staticRenderFns } from "./AdminFilters.vue?vue&type=template&id=066ae3f6&scoped=true"
import script from "./AdminFilters.vue?vue&type=script&lang=js"
export * from "./AdminFilters.vue?vue&type=script&lang=js"
import style0 from "./AdminFilters.vue?vue&type=style&index=0&id=066ae3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ae3f6",
  null
  
)

export default component.exports